export default __webpack_public_path__ + "media/images/gartenheim-rounded-a2da4fee6d097df007ab438300421f14.png";